export const ApplicantActionType = {
    StatusChange: "StatusChange",
    Contact: "Contact",
    Comment: "Comment",
    InterviewRoundCreated: "InterviewRoundCreated",
    InterviewRoundCompleted: "InterviewRoundCompleted",
    InterviewEvaluated: "InterviewEvaluated"
};

export const ApplicantActionTypeLabels = {
    [ApplicantActionType.StatusChange]: "Status Change",
    [ApplicantActionType.Contact]: "Contact",
    [ApplicantActionType.Comment]: "Comment",
    [ApplicantActionType.InterviewRoundCreated]: "Interview Round Created",
    [ApplicantActionType.InterviewRoundCompleted]: "Interview Round Completed",
    [ApplicantActionType.InterviewEvaluated]: "Interview Evaluated"
};

export const getApplicantActionTypeLabel = (action) =>
    ApplicantActionTypeLabels[action] || action;

export const getApplicantActionBadgeClass = (action) => {
    switch (action) {
    case ApplicantActionType.Contact:
        return "badge-info";
    case ApplicantActionType.Comment:
        return "badge-secondary";
    case ApplicantActionType.InterviewRoundCreated:
        return "badge-success";
    case ApplicantActionType.InterviewRoundCompleted:
        return "badge-warning";
    case ApplicantActionType.InterviewEvaluated:
        return "badge-dark";
    default:
        return "badge-primary";
    }
};
